import { z } from 'zod';
import { LEVELS, ROLES, CATEGORIES, define, DEFINITION_KINDS } from '../types.js';

/**
 * Whether to show price estimates before booking.
 */
export const schema = z.boolean();

export type PriceEstimates = z.infer<typeof schema>;

export const definition = define({
  key: 'price_estimates',
  schema,
  label: 'Activate Price Estimates',
  description:
    'Activate/Deactivate the price estimates feature for this client. This will allow the client to see price estimates for their moves before they create them.',
  kind: DEFINITION_KINDS.SETTING,
  category: CATEGORIES.MOVE_PLANNING.key,
  writableAtLevels: [
    LEVELS.HOPDRIVE,
    LEVELS.REGION,
    LEVELS.ORGANIZATION,
    LEVELS.CUSTOMER,
    LEVELS.WORKFLOWSET,
    LEVELS.RATERULEGROUP,
  ],
  readableByRoles: [ROLES.ADMIN],
  defaultValue: false,
});
